import {
  SUCCESS_SMS_STATUSES,
  FAILED_SMS_STATUSES,
  DIRECT_SND_SMS_SUCCESS_STATUSES,
  DIRECT_SND_SMS_FAILED_STATUSES,
  TWILIO_UNSUBSCRIBED_ERROR_CODE,
} from 'src/constants/misc';
import { TWILIO_ERROR_CODES } from 'src/constants/twilio-error-codes';
import { DIRECT_SND_ERROR_CODES } from 'src/constants/direct-snd-error-codes';
import { Chip, Tooltip } from '@mui/material';

// Resolve a human-readable error description. Twilio codes map to their message;
// DirectSND codes map to their description. Either falls back to the raw code
// when unmapped, mirroring how Twilio errors are surfaced. Some rows store the
// Twilio code as the string "null" (a stringified missing code), which is no code;
// DirectSND reports NO_ERROR on delivered messages, which is no error either.
export const getSmsErrorDescription = ({ twilioErrorCode, directSndErrorCode }) => {
  const twilioCode = twilioErrorCode === 'null' ? null : twilioErrorCode;
  if (twilioCode) {
    return TWILIO_ERROR_CODES[twilioCode]?.message ?? twilioCode;
  }
  if (directSndErrorCode && directSndErrorCode !== 'NO_ERROR') {
    return DIRECT_SND_ERROR_CODES[directSndErrorCode]?.Description ?? directSndErrorCode;
  }
  return null;
};

export const TwilioStatusBadge = ({ value, twilioErrorCode, directSndErrorCode }) => {
  let chipColor = 'warning';
  if ([...SUCCESS_SMS_STATUSES, ...DIRECT_SND_SMS_SUCCESS_STATUSES].includes(value)) {
    chipColor = 'success';
  }
  if ([...FAILED_SMS_STATUSES, ...DIRECT_SND_SMS_FAILED_STATUSES].includes(value)) {
    chipColor = 'error';
  }
  const chip = (
    <Chip
      sx={{ textTransform: 'capitalize' }}
      variant="soft"
      size="small"
      label={twilioErrorCode === `${TWILIO_UNSUBSCRIBED_ERROR_CODE}` ? 'UNSUBSCRIBED' : value}
      color={chipColor}
    />
  );

  if (!value && !twilioErrorCode && !directSndErrorCode) {
    return null;
  }

  const errorMessage = getSmsErrorDescription({ twilioErrorCode, directSndErrorCode });

  if (errorMessage) {
    return (
      <Tooltip title={errorMessage} arrow>
        {chip}
      </Tooltip>
    );
  }
  return chip;
};
